/* eslint-disable camelcase */
/* eslint-disable space-infix-ops */
'use strict';

/**
 * The Visidea javascript library that interacts with the APIs<br><br>
 * 1 - Include the library from cdn: https://cdn.visidea.ai/js-api-client/dist/visidea-api-client.min.js<br>
 * 2 - Instantiate a new object<br>
 * 3 - Call a public method<br>
 * @example <script type="text/javascript" async src="https://cdn.visidea.ai/js-api-client/dist/visidea-api-client.min.js"></script>
 * @example var visidea = new Visidea.Api('www.mywebsite.com', 'my_public_token');
 * @example visidea.item_view(12, 23);
 * @param {string} database_id - Database ID
 * @param {string} public_token - Public token
 * @param {Object} options - Custom options
 */

class Api {
  constructor(database_id, public_token, options) {
    options = options || {};
    this.conf = {};
    this.database_id = database_id;
    this.public_token = public_token;
    this.base_uri = options.base_uri || process.env.RECAPI_URI || 'https://api.visidea.ai/';
    this.async = options.async || true;
    this.currencies = {
      AED: 'د.إ',
      AFN: '؋',
      ALL: 'L',
      AMD: '֏',
      ANG: 'ƒ',
      AOA: 'Kz',
      ARS: '$',
      AUD: '$',
      AWG: 'ƒ',
      AZN: '₼',
      BAM: 'KM',
      BBD: '$',
      BDT: '৳',
      BGN: 'лв',
      BHD: '.د.ب',
      BIF: 'FBu',
      BMD: '$',
      BND: '$',
      BOB: '$b',
      BOV: 'BOV',
      BRL: 'R$',
      BSD: '$',
      BTC: '₿',
      BTN: 'Nu.',
      BWP: 'P',
      BYN: 'Br',
      BYR: 'Br',
      BZD: 'BZ$',
      CAD: '$',
      CDF: 'FC',
      CHE: 'CHE',
      CHF: 'CHF',
      CHW: 'CHW',
      CLF: 'CLF',
      CLP: '$',
      CNH: '¥',
      CNY: '¥',
      COP: '$',
      COU: 'COU',
      CRC: '₡',
      CUC: '$',
      CUP: '₱',
      CVE: '$',
      CZK: 'Kč',
      DJF: 'Fdj',
      DKK: 'kr',
      DOP: 'RD$',
      DZD: 'دج',
      EEK: 'kr',
      EGP: '£',
      ERN: 'Nfk',
      ETB: 'Br',
      ETH: 'Ξ',
      EUR: '€',
      FJD: '$',
      FKP: '£',
      GBP: '£',
      GEL: '₾',
      GGP: '£',
      GHC: '₵',
      GHS: 'GH₵',
      GIP: '£',
      GMD: 'D',
      GNF: 'FG',
      GTQ: 'Q',
      GYD: '$',
      HKD: '$',
      HNL: 'L',
      HRK: 'kn',
      HTG: 'G',
      HUF: 'Ft',
      IDR: 'Rp',
      ILS: '₪',
      IMP: '£',
      INR: '₹',
      IQD: 'ع.د',
      IRR: '﷼',
      ISK: 'kr',
      JEP: '£',
      JMD: 'J$',
      JOD: 'JD',
      JPY: '¥',
      KES: 'KSh',
      KGS: 'лв',
      KHR: '៛',
      KMF: 'CF',
      KPW: '₩',
      KRW: '₩',
      KWD: 'KD',
      KYD: '$',
      KZT: '₸',
      LAK: '₭',
      LBP: '£',
      LKR: '₨',
      LRD: '$',
      LSL: 'M',
      LTC: 'Ł',
      LTL: 'Lt',
      LVL: 'Ls',
      LYD: 'LD',
      MAD: 'MAD',
      MDL: 'lei',
      MGA: 'Ar',
      MKD: 'ден',
      MMK: 'K',
      MNT: '₮',
      MOP: 'MOP$',
      MRO: 'UM',
      MRU: 'UM',
      MUR: '₨',
      MVR: 'Rf',
      MWK: 'MK',
      MXN: '$',
      MXV: 'MXV',
      MYR: 'RM',
      MZN: 'MT',
      NAD: '$',
      NGN: '₦',
      NIO: 'C$',
      NOK: 'kr',
      NPR: '₨',
      NZD: '$',
      OMR: '﷼',
      PAB: 'B/.',
      PEN: 'S/.',
      PGK: 'K',
      PHP: '₱',
      PKR: '₨',
      PLN: 'zł',
      PYG: 'Gs',
      QAR: '﷼',
      RMB: '￥',
      RON: 'lei',
      RSD: 'Дин.',
      RUB: '₽',
      RWF: 'R₣',
      SAR: '﷼',
      SBD: '$',
      SCR: '₨',
      SDG: 'ج.س.',
      SEK: 'kr',
      SGD: 'S$',
      SHP: '£',
      SLL: 'Le',
      SOS: 'S',
      SRD: '$',
      SSP: '£',
      STD: 'Db',
      STN: 'Db',
      SVC: '$',
      SYP: '£',
      SZL: 'E',
      THB: '฿',
      TJS: 'SM',
      TMT: 'T',
      TND: 'د.ت',
      TOP: 'T$',
      TRL: '₤',
      TRY: '₺',
      TTD: 'TT$',
      TVD: '$',
      TWD: 'NT$',
      TZS: 'TSh',
      UAH: '₴',
      UGX: 'USh',
      USD: '$',
      UYI: 'UYI',
      UYU: '$U',
      UYW: 'UYW',
      UZS: 'лв',
      VEF: 'Bs',
      VES: 'Bs.S',
      VND: '₫',
      VUV: 'VT',
      WST: 'WS$',
      XAF: 'FCFA',
      XBT: 'Ƀ',
      XCD: '$',
      XOF: 'CFA',
      XPF: '₣',
      XSU: 'Sucre',
      XUA: 'XUA',
      YER: '﷼',
      ZAR: 'R',
      ZMW: 'ZK',
      ZWD: 'Z$',
      ZWL: '$'
    };
    this._settings();
  }

  /**
   * Track the view of an item.
   * @param {string} item_id - the id of the item viewed
   * @param {string} user_id - the id of the user
   * @param {function} callback - the callback to be called
   */
  item_view(item_id, user_id, callback) {
    this._request('api/interactions', 'POST', { item_id: item_id, user_id: user_id, action: 'view' }, callback, {});
  }

  /**
   * Track an item added to cart.
   * @param {string} item_id - the id of the item added to cart
   * @param {string} user_id - the id of the user
   * @param {function} callback - the callback to be called
   */
  item_cart(item_id, user_id, callback) {
    this._request('api/interactions', 'POST', { item_id: item_id, user_id: user_id, action: 'cart' }, callback, {});
  }

  /**
   * Track the purchase of an item.
   * @param {string} item_id - the id of the item purchased
   * @param {string} user_id - the id of the user
   * @param {function} callback - the callback to be called
   */
  item_purchase(item_id, user_id, callback) {
    this._request('api/interactions', 'POST', { item_id: item_id, user_id: user_id, action: 'purchase' }, callback, {});
  }

  /**
   * Track an item added to wishlist.
   * @param {string} item_id - the id of the item added to wishlist
   * @param {string} user_id - the id of the user
   * @param {function} callback - the callback to be called
   */
  item_favorite(item_id, user_id, callback) {
    this._request('api/interactions', 'POST', { item_id: item_id, user_id: user_id, action: 'favorite' }, callback, {});
  }

  /**
   * Merge two users.
   * @param {string} old_user_id - the id of the old user
   * @param {string} new_user_id - the id of the new user
   * @param {function} callback - the callback to be called
   */
  merge_users(old_user_id, new_user_id, callback) {
    this._request('api/merge_users', 'POST', { old_user_id: old_user_id, new_user_id: new_user_id }, callback, {});
  }

  /**
   * Recommend items.
   * @param {string} algo - the algorithm to be used (one of this list: user | item | similarity | pop)
   * @param {string} user_id - the id of the user
   * @param {string} item_id - the id of the item (if algo is item)
   * @param {array} query - the query to pass to the recommendation engine
   * @param {number} n_rec - how many recommendation we ask to be fetched from server
   * @param {function} callback - the callback to be called
   * @param {array} params - array of params to be passed to the callback
   */
  recommend(algo, user_id, item_id, query, n_rec, callback, params) {
    var obj = { algo: algo, n_rec: n_rec, user_id: user_id };
    if (algo === 'item' || algo === 'similarity') {
      obj.item_id = item_id;
    }
    if (query !== {}) {
      obj.query = query;
    }
    this._request('api/recommend', 'POST', obj, callback, params);
  }

  /**
   * Visual seach.
   * @param {string} img - the image to be searched (base64 encoded)
   * @param {string} user_id - the id of the user
   * @param {function} callback - the callback to be called
   * @param {array} params - array of params to be passed to the callback
   */
  visualsearch(img, user_id, callback, params) {
    var obj = { img: img, user_id: user_id };
    this._request('api/visualsearch', 'POST', obj, callback, params);
  }

  /**
  * Visual recommend items.
   * @param {string} img - the image to be searched (base64 encoded)
   * @param {string} user_id - the id of the user
   * @param {number} n_rec - how many recommendation we ask to be fetched from server
   * @param {string} detected_class - the dected class of the crop returned by the visualsearch method
   * @param {function} callback - the callback to be called
   * @param {array} params - array of params to be passed to the callback
   */
  visualrecommend(img, user_id, n_rec, detected_class, callback, params) {
    var obj = { img: img, user_id: user_id, n_rec: n_rec, detected_class: detected_class };
    this._request('api/visualrecommend', 'POST', obj, callback, params);
  }

  /**
   * This function returns an unique uuid (use if your cms don't provide a userid for anonymous users).
   */
  uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
  }

  /**
   * This function returns the price formatted accordingly to format and currency.
   * @param {number} price - price that has to be formatted
   * @param {string} currency - the currency
   * @param {string} format - string containing the format information
   */
  format_currency(price) {
    var number = parseFloat(price);
    if (Number.isNaN(number)) {
      number = 0;
    }
    var currency = this.conf.currency;
    var format = this.conf.currency_format;
    var currency_string = currency;
    if (currency === 'EUR') currency_string = 'Euro';
    switch (format) {
      case 'amountwithcomma_currency':
        return number.toFixed(2).replace('.', ',') + ' ' + currency_string;
      case 'amountwithdot_currency':
        return number.toFixed(2) + ' ' + currency_string;
      case 'currency_amountwithcomma':
        return currency_string + ' ' + number.toFixed(2).replace('.', ',');
      case 'currency_amountwithdot':
        return currency_string + ' ' + number.toFixed(2);
      case 'amountwithcomma_symbol':
        return number.toFixed(2).replace('.', ',') + ' ' + this.currencies[currency];
      case 'amountwithdot_symbol':
        return number.toFixed(2) + ' ' + this.currencies[currency];
      case 'symbol_amountwithcomma':
        return this.currencies[currency] + ' ' + number.toFixed(2).replace('.', ',');
      case 'symbol_amountwithdot':
        return this.currencies[currency] + ' ' + number.toFixed(2);
      default:
        return number.toFixed(2) + ' ' + currency_string;
    }
  }

  /**
   * Private method: This function load settings from server.
   */
  _settings() {
    var self = this;
    this._request('api/settings', 'GET', {}, function (data) {
      self.conf = data;
    }, {});
  }

  /**
   * Private method: This function call a specific api endpoint via method specified by param.
   * @param {string} path - the path to be called
   * @param {string} method - the http method to be called
   * @param {string} params - the params to be send as json via POST
   * @param {function} callback - the callback to be called
   * @param {function} cparams - params to be passed to the callback
   */
  _request(path, method, params, callback, cparams) {
    var xhr = new XMLHttpRequest();
    var url = this.base_uri + path;
    if (method === 'GET' && params.lenght > 0) {
      url += '?' + new URLSearchParams(params).toString();
    }
    xhr.open(method, url, true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Recommendify-Token', this.public_token);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        if (typeof callback === 'function') {
          return callback(JSON.parse(this.responseText), cparams);
        }
      }
    };
    if (method === 'GET') {
      xhr.send();
    }
    if (method === 'POST') {
      xhr.send(JSON.stringify(params));
    }
  }
}

exports.Api = Api;


//////////////////
// WEBPACK FOOTER
// ./src/api.js
// module id = 2
// module chunks = 0